module.exports = __webpack_public_path__ + "2ab0af51e5a31dbe6a75e0f98b70ba3a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/acne/acne-1b.jpg
 ** module id = 428
 ** module chunks = 0
 **/